<script>
  /**
   * @type {{
   *   title?: string,
   *   subtitle?: string,
   *   email?: string,
   *   name?: string,
   *   message?: string,
   *   error?: string,
   *   subscribing?: boolean,
   *   onEmailChange?: (value: string) => void,
   *   onNameChange?: (value: string) => void,
   *   onSubscribe?: () => void
   * }}
   */
  let {
    title = '소식 받기',
    subtitle = '이메일을 남기면 새 링크와 소식을 받을 수 있습니다.',
    email = '',
    name = '',
    message = '',
    error = '',
    subscribing = false,
    onEmailChange = undefined,
    onNameChange = undefined,
    onSubscribe = undefined,
  } = $props()
</script>

<div class="capture-card">
  <div class="capture-title">{title}</div>
  <div class="capture-subtitle">{subtitle}</div>

  {#if message}
    <div class="capture-success">{message}</div>
  {/if}

  {#if error}
    <div class="capture-error">{error}</div>
  {/if}

  <div class="capture-form">
    <input
      type="text"
      class="capture-input"
      placeholder="이름 (선택)"
      value={name}
      oninput={(event) => onNameChange?.(event.currentTarget.value)}
    />
    <input
      type="email"
      class="capture-input"
      placeholder="you@example.com"
      value={email}
      oninput={(event) => onEmailChange?.(event.currentTarget.value)}
    />
    <button type="button" class="capture-button" disabled={subscribing || !email} onclick={() => onSubscribe?.()}>
      {subscribing ? '등록 중...' : '구독하기'}
    </button>
  </div>
</div>

<style>
  .capture-card {
    margin-top: 18px;
    padding: 16px;
    border-radius: var(--card-radius);
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    box-shadow: var(--card-shadow);
  }

  .capture-title {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .capture-subtitle {
    margin-top: 8px;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.5;
  }

  .capture-form {
    display: grid;
    gap: 10px;
    margin-top: 14px;
  }

  .capture-input {
    width: 100%;
    border: 1px solid var(--card-border);
    background: color-mix(in srgb, var(--card-bg, #fff) 80%, transparent);
    color: var(--text-primary);
    border-radius: 9999px;
    padding: 12px 16px;
    font-size: 14px;
    outline: none;
    font-family: inherit;
    transition: border-color 150ms ease, box-shadow 150ms ease;
  }

  .capture-input:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 12%, transparent);
  }

  .capture-input::placeholder {
    color: var(--text-tertiary);
  }

  .capture-button {
    border: 1px solid var(--button-border, var(--card-border));
    background: var(--button-bg, var(--accent, var(--card-hover)));
    color: var(--button-text, var(--avatar-text, #fff));
    border-radius: 9999px;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 150ms ease;
    font-family: inherit;
    width: 100%;
  }

  .capture-button:hover {
    background: var(--card-hover, var(--button-bg, var(--accent, var(--card-hover))));
  }

  .capture-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .capture-success,
  .capture-error {
    margin-top: 12px;
    padding: 10px 12px;
    border-radius: 12px;
    font-size: 13px;
  }

  .capture-success {
    background: var(--success-bg, rgba(16, 185, 129, 0.12));
    color: var(--success-text, #047857);
  }

  .capture-error {
    background: var(--error-bg, rgba(244, 63, 94, 0.12));
    color: var(--error-text, #be123c);
  }
</style>
